import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export default function LegalPageLayout({ testId, eyebrowIcon: EyebrowIcon, eyebrow, title, accent, updated, sections, contactLine, contactEmail }) {
  return (
    <div className="min-h-screen bg-[#f9f9f8] text-[#111]">
      <header className="fixed top-0 inset-x-0 z-50 bg-[#f9f9f8]/85 backdrop-blur-xl border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid={`${testId}-logo-link`}><Logo /></Link>
          <Link to="/" data-testid={`${testId}-back-link`} className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-[#111] transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 pt-36 pb-24">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 text-xs font-mono-data uppercase tracking-[0.2em] text-neutral-500 mb-6">
            <EyebrowIcon className="w-4 h-4" /> {eyebrow}
          </div>
          <h1 className="font-heading font-light text-4xl sm:text-5xl tracking-tighter leading-[1.05]" data-testid={`${testId}-title`}>
            {title} <span className="font-serif-accent italic text-neutral-500">{accent}</span>
          </h1>
          <p className="mt-6 text-sm text-neutral-500 font-mono-data">Last updated: {updated}</p>
        </div>

        <div className="mt-14 space-y-12">
          {sections.map((s) => (
            <section key={s.id} id={s.id} data-testid={`${testId}-section-${s.id}`}>
              <h2 className="font-heading text-lg font-medium">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-3 text-sm text-neutral-600 leading-relaxed">{p}</p>
              ))}
              {s.list && (
                <ul className="mt-3 space-y-2">
                  {s.list.map((item, i) => (
                    <li key={i} className="text-sm text-neutral-600 leading-relaxed flex gap-2.5">
                      <span className="text-neutral-300 shrink-0">—</span> {item}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        <div className="mt-16 bg-[#111] text-white rounded-lg p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-neutral-300">{contactLine}</p>
          <a href={`mailto:${contactEmail}`} data-testid={`${testId}-contact-link`} className="text-sm bg-white text-[#111] rounded-full px-5 py-2.5 font-medium hover:bg-neutral-200 transition-colors">{contactEmail}</a>
        </div>

        <nav className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm text-neutral-500">
          <Link to="/privacy" className="hover:text-[#111] transition-colors">Privacy Policy</Link>
          <Link to="/cookies" className="hover:text-[#111] transition-colors">Cookies Policy</Link>
          <Link to="/terms" className="hover:text-[#111] transition-colors">Terms of Service</Link>
          <Link to="/trust" className="hover:text-[#111] transition-colors">Security &amp; Trust Center</Link>
        </nav>
      </main>

      <footer className="border-t border-neutral-200 px-6 py-10">
        <div className="max-w-4xl mx-auto flex items-center justify-between text-sm text-neutral-500">
          <Logo />
          <p className="text-xs">© 2026 EXOPILOT</p>
        </div>
      </footer>
    </div>
  );
}
